module.exports = __webpack_public_path__ + "static/media/camera.726c4cce.svg";